var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKeyUses(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#108D5C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5254 12.97C13.5254 11.93 12.5954 11.59 11.4354 11.59H11.2854V10.76H11.4054C12.6654 10.76 13.3354 10.41 13.3354 9.56C13.3354 8.78 12.6954 8.38 11.9254 8.38C10.9554 8.38 10.4254 8.97 10.3454 9.79H9.40543C9.51543 8.51 10.4254 7.62 11.9454 7.62C13.2054 7.62 14.2954 8.12 14.2954 9.46C14.2954 10.2 13.8754 10.83 13.1154 11.14C14.1954 11.48 14.4954 12.2 14.4954 12.96C14.4954 14.42 13.2554 15.13 11.8754 15.13C10.1754 15.13 9.39543 14.07 9.29543 12.86H10.2354C10.3354 13.75 10.8654 14.37 11.8854 14.37C12.8454 14.37 13.5254 13.87 13.5254 12.97Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyUses);
export default __webpack_public_path__ + "static/media/key_uses.d86b2eea3ca59031c0b93d6dbda91aed.svg";
export { ForwardRef as ReactComponent };